import FiltersPanelAsForm from './FiltersPanelAsForm'

export default FiltersPanelAsForm
